/**
 * Пустое состояние (§2.3, §4.7, §11.2, §12.8).
 *
 * Заголовок, объяснение с числом и выход одной кнопкой. Тексты — дословно из
 * §12.8, поэтому приходят пропсами: компонент не придумывает формулировок.
 * Иллюстраций нет (§2.3).
 */
import type { ReactNode } from 'react'
import './EmptyState.css'

export interface EmptyStateProps {
  title: string
  /** Объяснение с числом: «Искать среди всех 230 брендов канала Розница». */
  text?: ReactNode
  /** Кнопки: главная — `secondary`, вторая — `ghost` (§2.3). */
  actions?: ReactNode
  className?: string
}

export function EmptyState({ title, text, actions, className }: EmptyStateProps) {
  const classes = ['empty-state']
  if (className) classes.push(className)

  return (
    <div className={classes.join(' ')}>
      <h2 className="empty-state__title t-h2">{title}</h2>
      {text ? <p className="empty-state__text t-cell">{text}</p> : null}
      {actions ? <div className="empty-state__actions">{actions}</div> : null}
    </div>
  )
}
